import { useEffect, useRef, useState } from 'react';

interface UseGridResizeProps {
    readyToDraw: boolean;
}

interface UseGridResizeReturn {
    boxTableRef: React.RefObject<HTMLDivElement>;
    gridWidth: number;
    setGridWidth: (width: number) => void;
    gridWidthApplied: boolean;
    setGridWidthApplied: (applied: boolean) => void;
}

export const useGridResize = ({ readyToDraw }: UseGridResizeProps): UseGridResizeReturn => {
    const boxTableRef = useRef<HTMLDivElement | null>(null);
    const [gridWidth, setGridWidth] = useState(0);
    const [gridWidthApplied, setGridWidthApplied] = useState(false);

    const onContainerResize = () => {
        if (boxTableRef && boxTableRef.current && boxTableRef.current.offsetWidth > 0) {
            setGridWidth(boxTableRef.current.offsetWidth);
            setGridWidthApplied(true);
        }
    };

    const resizeObserver = new ResizeObserver(onContainerResize);

    useEffect(() => {
        if (readyToDraw && boxTableRef && boxTableRef.current) {
            resizeObserver.observe(boxTableRef.current);
        }
    }, [readyToDraw]);

    useEffect(() => {
        return () => {
            if (boxTableRef.current) {
                resizeObserver.unobserve(boxTableRef.current);
            }
        };
    }, []);

    return {
        boxTableRef,
        gridWidth,
        setGridWidth,
        gridWidthApplied,
        setGridWidthApplied,
    };
};
